// extracted by mini-css-extract-plugin
export default {"form":"selection-filter-modal_form__u1EpB","description":"selection-filter-modal_description__NsfK9","checkbox":"selection-filter-modal_checkbox__O8W90"};